import React from "react";
import {
  PeopleContainer,
  PeopleWrapper,
  PeopleTitle,
  PeopleCardOverviewContainer,
  PeopleOverviewContainer,
} from "./styles";
import { PeopleCard, PeopleList } from "@caelor/ui";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import { usePeopleStore } from "../../../../../../stores/use-people-store";
import { OVERVIEW_DUMMY_DATA } from "./data";
import { MACRO_KEY } from "../../../../../defaults";
import { useStyleguideColors } from "../../../../../../hooks/use-styleguide-colors";
import { DEFAULT_ACCENT_COLOR } from "../../../../../../features/people/defaults";
import { buildTemplate, PEOPLE_TEMPLATES } from "./people-templates";

const CardRender = ({ accent, borderRadius }) => {
  return (
    <div style={{ display: "flex", flexFlow: "row", gap: 8 }}>
      <div style={{ width: 166 }}>
        <PeopleCard
          name="Ava Turner"
          avatarUrl="/img/peopleList.svg"
          subtitle="Lead designer"
          label="Design"
          accentColor={accent || DEFAULT_ACCENT_COLOR}
          isTemplate
          borderRadius={borderRadius}
        />
      </div>
      <div style={{ width: 166 }}>
        <PeopleCard
          name="Liam Brooks"
          avatarUrl="/img/peopleCard.svg"
          subtitle="Senior developer"
          label="Development"
          accentColor={accent || DEFAULT_ACCENT_COLOR}
          isTemplate
          borderRadius={borderRadius}
        />
      </div>
    </div>
  );
};

const ListRender = ({ accent, borderRadius }) => {
  return (
    <div style={{ display: "flex", flexFlow: "column", gap: 8 }}>
      <div style={{ width: 475 }}>
        <PeopleList
          name="Angelica Lorens"
          avatarUrl="/img/peopleList.svg"
          subtitle="Marketing manager"
          label="Design"
          accentColor={accent || DEFAULT_ACCENT_COLOR}
          isTemplate
          borderRadius={borderRadius}
        />
      </div>
      <div style={{ width: 475 }}>
        <PeopleList
          name="Liam Brooks"
          avatarUrl="/img/peopleCard.svg"
          subtitle="Senior developer"
          label="Design"
          accentColor={accent || DEFAULT_ACCENT_COLOR}
          isTemplate
          borderRadius={borderRadius}
        />
      </div>
      <div style={{ width: 475 }}>
        <PeopleList
          name="Ava Turner"
          avatarUrl="/img/peopleList.svg"
          subtitle="Lead designer"
          label="Design"
          accentColor={accent || DEFAULT_ACCENT_COLOR}
          isTemplate
          borderRadius={borderRadius}
        />
      </div>
    </div>
  );
};

const VIEWS = {
  card: { label: "Card", View: CardRender },
  list: { label: "List", View: ListRender },
};

export const OverviewTemplates = () => {
  const { setMacro, setDrawers, colorPalette, styleguideSetup } =
    useOpticsStore((state) => ({
      setMacro: state.setMacro,
      setDrawers: state.setDrawers,
      colorPalette: state.colorPalette,
      styleguideSetup: state.styleguideSetup,
    }));

  const { setData } = usePeopleStore((state) => ({
    setData: state.setData,
  }));

  const borderRadius = styleguideSetup?.cornerRadius || 3;

  return (
    <PeopleOverviewContainer
      onClick={() => {
        setMacro({ key: MACRO_KEY.PEOPLE });
        setData({ ...buildTemplate("card", borderRadius) });
        setDrawers({ templates: false, settings: true });
      }}
    >
      {OVERVIEW_DUMMY_DATA.map((person) => (
        <PeopleCardOverviewContainer>
          <PeopleCard
            name={person.name}
            avatarUrl={person.avatarUrl}
            subtitle={person.subtitle}
            label={person.label}
            accentColor={colorPalette?.accent}
            borderRadius={borderRadius}
          />
        </PeopleCardOverviewContainer>
      ))}
    </PeopleOverviewContainer>
  );
};

const PeopleTemplates = () => {
  const { data, setData, config } = usePeopleStore((state) => ({
    data: state.data,
    setData: state.setData,
    config: state.data.config,
  }));

  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  const color =
    config?.accentColor || styleguideColors?.accent || DEFAULT_ACCENT_COLOR;

  const borderRadius =
    config?.cardBorderRadius || styleguideSetup?.cornerRadius || 3;

  const buildData = (template, value) => {
    if (Object.keys(data || {}).length) {
      return {
        ...data,
        config: {
          ...data.config,
          variant: value.variant,
        },
      };
    }

    const newData = {
      ...template,
      config: { ...template.config, ...value },
    };
    return newData;
  };

  return (
    <PeopleContainer>
      {PEOPLE_TEMPLATES.map((template) => {
        const { label, View } = VIEWS[template.config.variant];
        return (
          <PeopleWrapper
            onClick={() => {
              setData({
                ...buildData(template, {
                  accentColor: color,
                  cardBorderRadius: borderRadius,
                  variant: template.config.variant,
                }),
              });
              setDrawers({ templates: false, settings: true });
            }}
          >
            <PeopleTitle>{label}</PeopleTitle>
            <View accent={color} borderRadius={borderRadius} />
          </PeopleWrapper>
        );
      })}
    </PeopleContainer>
  );
};

export default PeopleTemplates;
